import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Merch({ merch = {} }) {
  return (
    <section id="merch" className="relative overflow-hidden min-h-[70vh] flex items-center py-24 md:py-40" data-testid="merch-section">
      <div className="absolute inset-0">
        {merch.image && <img src={merch.image} alt="masterclass" className="w-full h-full object-cover opacity-30" />}
        <div className="absolute inset-0 bg-gradient-to-r from-obsidian via-obsidian/85 to-obsidian/40" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 20% 50%, rgba(79, 176, 74,0.14), transparent 55%)" }} />
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 w-full">
        <Reveal className="max-w-3xl">
          <p className="overline text-gold mb-6">{merch.overline || "Learn From The Source"}</p>
          <h2 className="headline text-5xl md:text-8xl text-white mb-8 leading-[0.9]">{merch.heading || "Learn The Craft."}</h2>
          <p className="text-white/70 font-body text-lg md:text-xl leading-relaxed max-w-xl mb-12">{merch.description}</p>

          {merch.masterclass_url && (
            <a
              href={merch.masterclass_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="merch-masterclass-btn"
              className="group inline-flex items-center justify-center gap-3 bg-gold text-black font-display uppercase tracking-[0.2em] text-sm px-10 py-5 hover:bg-white transition-colors duration-300"
            >
              {merch.masterclass_label || "Take The MasterClass"}
              <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          )}
        </Reveal>
      </div>
    </section>
  );
}
